import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class TitleService {
  currentTitle$ = new BehaviorSubject<string | false>(false);

  constructor() {}
}
